const MAX = 100
const MAXINVENTORY = 10

export { MAX, MAXINVENTORY }



// WEBPACK FOOTER //
// ./src/data/constants.js